import React, { Component } from 'react';
import logo from './logo.svg';
import Auth from './components/Auth';
import Form from './components/Form';
import firebase from 'firebase';
import AuthButton from './components/AuthButton'
import './App.css';
import Map from './components/Map.js'
import EventForm from './components/EventForm.js'
import {colors} from './utils/constants.js';
import Profile from './components/Profile.js'
import { HashRouter, BrowserRouter, Switch, Route } from 'react-router-dom';
import {auth} from './firebase/firebase.js';

class App extends Component {
  constructor() {
    super();
    this.state ={
      loggedIn : false,
    }
  }
  componentDidMount(){
    this.authFirebaseListener = firebase.auth().onAuthStateChanged((user) =>{
      this.setState({loggedIn : !!user, uid: user.uid})
      console.log(user)
    })
  }

  render() {
    return (
      <div className="App">
        <div className="mainWrapper">     
            <div className="headerLogo" style={{ zIndex: 100, display: "flex", justifyContent: "flex-end", backgroundColor: colors.indigo}}> Racoon.io
            <AuthButton loggedIn={this.state.loggedIn}></AuthButton></div>
            <div className="UIFrame" style={{ backgroundColor: colors.lightIndigo}} >
            <HashRouter>
              <Switch>
              <Route exact path='/' component={Map}/>
              <Route path='/event' component={EventForm}/>
              <Route path='/profile' render={(props) => <Profile uid={this.state.uid}/>}/>
              </Switch>
              </HashRouter>
            </div>

            <div className = "iconFlex" style={{ backgroundColor: colors.indigo}} >
              <a href="/" style={{textDecoration:"none"}}>
                <span className="fa-stack fa-lg">
                    <i className="fa fa-square fa-stack-2x" style = {{color:colors.lightIndigo}}></i>
                    <i className="fa fa-map fa-stack-1x fa-inverse"></i>
                </span>
              </a>
              {/* <a href="#"style={{textDecoration:"none"}}>
                <span className="fa-stack fa-lg">
                  <i className="fa fa-square fa-stack-2x" style = {{color:colors.lightIndigo}}></i>
                  <i className="fa fa-calendar fa-stack-1x fa-inverse"></i>
                </span>
              </a> */}
              
              <a onClick={ () => {
                if (this.state.loggedIn) {
                  window.location.href = '/#/event'
                } else {
                  alert("You aren't logged in!")
                }

              }}  style={{textDecoration:"none"}}>
                <span className="fa-stack fa-lg">
                  <i className="fa fa-square fa-stack-2x" style = {{color:colors.lightIndigo}}></i>
                  <i className="fa fa-plus fa-stack-1x fa-inverse"></i>
                </span>
              </a>
              <a onClick={ () => {
                if (this.state.loggedIn) {
                  window.location.href = '/#/profile'
                } else {
                  alert("You aren't logged in!")
                }

              }} style={{textDecoration:"none"}}>
                <span className="fa-stack fa-lg">
                    <i className="fa fa-square fa-stack-2x" style = {{color: colors.lightIndigo}}></i>
                    <i className="fa fa-user fa-stack-1x fa-inverse"></i>
                  </span>
              </a>
          </div>
        </div>
      </div>
    );
  }
}

export default App;